export default __webpack_public_path__ + "static/logo-89879532546e001c5dee3f5e9f6ccfe6.svg";